var render, staticRenderFns
import script from "./AntIcon.vue?vue&type=script&lang=js"
export * from "./AntIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51464471')) {
      api.createRecord('51464471', component.options)
    } else {
      api.reload('51464471', component.options)
    }
    
  }
}
component.options.__file = "src/components/antIcon/AntIcon.vue"
export default component.exports